import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '../views/Dashboard.vue';
import store from '../store';
import Login from '../views/Login';
import Register from '../views/Register';
import Message from '../views/Message';
import MessageLookup from '../views/MessageLookup';
import MessageCreate from '../views/MessageCreate';
import MessageView from '../views/MessageView';
import Employee from '../views/Employee';
import EmployeeLookup from '../views/EmployeeLookup';
import EmployeeCreate from '../views/EmployeeCreate';
import EmployeeView from '../views/EmployeeView';
import MessageGroup from '../views/MessageGroup';
import MessageGroupLookup from '../views/MessageGroupLookup';
import MessageGroupCreate from '../views/MessageGroupCreate';
import MessageGroupView from '../views/MessageGroupView';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            authRequired: true
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            authRequired: false
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            authRequired: false
        }
    },
    {
        path: '/message',
        component: Message,
        children: [
            { path: 'lookup', component: MessageLookup },
            { path: 'create', component: MessageCreate },
            { path: 'view/:messageUid', component: MessageView, props: true }
        ],
        meta: {
            authRequired: true
        }
    },
    {
        path: '/employee',
        component: Employee,
        children: [
            { path: 'lookup', component: EmployeeLookup },
            { path: 'create', component: EmployeeCreate },
            { path: 'view/:employeeUid', component: EmployeeView, props: true }
        ],
        meta: {
            authRequired: true
        }
    },
    {
        path: '/message-group',
        component: MessageGroup,
        children: [
            { path: 'lookup', component: MessageGroupLookup },
            { path: 'create', component: MessageGroupCreate },
            { path: 'view/:messageGroupUid', component: MessageGroupView, props: true }
        ],
        meta: {
            authRequired: true
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    // Applies to any route with authRequired defined as true
    // TODO: Change to require auth by default, unless set otherwise
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.getters.isAuthenticated) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
